const Alert = ({show, value, type}) => (
  <div
    className={`c-alert-message ${type === 'info' ? 'info' : 'alert'} ${show ? 'show' : ''}`}
  >
    {value}
  </div>
)

export default Alert
